import NotificationBar from './NotificationBar'

export default NotificationBar


// WEBPACK FOOTER //
// app/javascript/components/NotificationBar/index.js